import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { faRadar } from "@fortawesome/pro-regular-svg-icons";

import { Modal } from "@/components";
import { AutoComplete, AutoCompleteItem } from "@/components/AutoComplete/AutoComplete";

interface AddToTrackerModalProps {
	trackerLists: { id: number; name: string }[];
	isLoadingTrackerLists: boolean;
	isFetchingTrackerLists: boolean;
	selectedTracker?: AutoCompleteItem;
	isSaving: boolean;
	onSearch: (value: string) => void;
	onSelect: (value?: AutoCompleteItem) => void;
	onConfirm: () => void;
	onClose: () => void;
}

/** Picks the Profile Tracker a selection of companies is added to. */
export const AddToTrackerModal: FunctionComponent<AddToTrackerModalProps> = ({
	trackerLists,
	isLoadingTrackerLists,
	isFetchingTrackerLists,
	selectedTracker,
	isSaving,
	onSearch,
	onSelect,
	onConfirm,
	onClose,
}) => {
	const { t } = useTranslation();
	const ts = (key: string) => t(`contacts.${key}`);

	return (
		<Modal
			handleClose={onClose}
			handleSave={onConfirm}
			isLoading={isSaving}
			isOpened
			size="md"
			submitButtonText={t("basics.confirm")}
			title={ts("addToTrackerTitle")}
		>
			<div className="mb-4 flex flex-row items-center">
				{!isLoadingTrackerLists && (
					<AutoComplete
						data={trackerLists.map((list) => ({ id: list.id, title: list.name }))}
						handleSearch={onSearch}
						handleSelect={onSelect}
						icon={faRadar}
						isLoading={isLoadingTrackerLists || isFetchingTrackerLists}
						label={ts("trackerList")}
						placeholder={ts("searchTracker")}
						selectedItem={selectedTracker?.title || ""}
					/>
				)}
			</div>
		</Modal>
	);
};
